<template>
  <LayoutShellFlat>
    <template #nav>
      <NavBarOrganizationSettings />
    </template>
    <slot />
  </LayoutShellFlat>
</template>
